import { render, staticRenderFns } from "./user-edit-box.vue?vue&type=template&id=62d5383f&scoped=true&"
import script from "./user-edit-box.vue?vue&type=script&lang=js&"
export * from "./user-edit-box.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-box.vue?vue&type=style&index=0&id=62d5383f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d5383f",
  null
  
)

export default component.exports